import { useEffect, useRef, useState } from "react";
import '../../style/login.css';
import { setCookie } from '../../utils/cookie';
import BackgroundImage from '../../assets/gobg.jpg';
import { Input, Button, ConfigProvider, message, Space, Spin } from 'antd';
import { useLoginWithMFA } from "./use_mfa_callback";
import { LoadingOutlined } from "@ant-design/icons";

const { Password, OTP } = Input;

const LoginPanel = (props) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState();
    const [pwd, setPwd] = useState();
    const [needRedirect, setNeedRedirect] = useState(false);
    const [loading, setLoading] = useState(false);
    const [mfaLoading, setMfaLoading] = useState(false);
    const total = 60;
    const timerRef = useRef(null);
    const [counter, setCounter] = useState(0);
    const [canResend, setCanResend] = useState(false);

    const {
        user,
        error: mfaError,
        mfaRequired,
        phoneNumber,
        loginWithEmail,
        verifyCode,
        resendCode,
    } = useLoginWithMFA();

    useEffect(() => {
    }, [])

    useEffect(() => {
        if (username) {
            setNeedRedirect(true);
        }
    }, [username]);

    useEffect(() => {
        if (needRedirect) {
            window.location.reload();
        }
    }, [needRedirect])

    const emailInput = (evt) => {
        setEmail(evt.target.value)
    }

    const pwdInput = (evt) => {
        setPwd(evt.target.value);
    }

    const confirmLogin = async () => {
        if (!email || !pwd) return;
        setLoading(true);

        try {
            await loginWithEmail(email, pwd);
        } catch (error) {
            // MFA 错误会在 useEffect 中处理
            if (!error.message?.includes('multi-factor-auth-required')) {
                setLoading(false);
                message.error(error.message || 'Sign in failed, please try again');
            }
        } finally {
            setMfaLoading(false);
        }
    }

    // 处理 MFA 登录成功
    useEffect(() => {
        if (user) {
            handleLoginSuccess(user);
        }
    }, [user]);

    // 处理 MFA 错误
    useEffect(() => {
        if (mfaError) {
            setLoading(false);
            message.error(mfaError);
        }
    }, [mfaError]);


    const handleLoginSuccess = async (firebaseUser) => {
        console.log('firebaseUser', firebaseUser);
        try {
            let token = await firebaseUser.getIdToken();
            setCookie('user-token', token);
            setUsername(firebaseUser.email);
        } catch (error) {
            setLoading(false);
            message.error(error.message || 'Login processing failed');
        }
    };


    const onChange = async (text) => {
        setMfaLoading(true);
        await verifyCode(text);
    };

    const sharedProps = {
        onChange,
    };

    useEffect(() => {
        if (mfaRequired) {
            startSeconds();
        } else {
            clearInterval(timerRef.current);
        }
    }, [mfaRequired])

    useEffect(() => {
        if (counter >= total) {
            setCanResend(true);
            setMfaLoading(false);
            clearInterval(timerRef.current)
        }
    }, [counter])

    const startSeconds = () => {
        timerRef.current = setInterval(() => {
            setCounter((value) => (value + 1))
        }, 1000)
    }

    const sendOtp = async () => {
        setCounter(0);
        setCanResend(false);
        setMfaLoading(true);

        await resendCode();
        setMfaLoading(false);
        startSeconds();
    }

    const getSecondsDesc = () => {
        return `${total - counter}s`
    }

    return (
        <ConfigProvider theme={{
            components: {
                Button: {
                    colorBgContainerDisabled: '#D0DFFC',
                    colorBgContainer: '#0266FF',
                    colorTextDisabled: 'white',
                    borderColorDisabled: '#D0DFFC'
                }
            }
        }}>
            <div className="main" style={{ backgroundImage: `url(${BackgroundImage})` }}>
                <div className="login-form">
                    <h1>Addx Go Admin</h1>
                    <div className="head">
                        <img src='/images/logo.png' alt="" />
                    </div>

                    {
                        mfaRequired ?
                            <div style={{ textAlign: 'center' }}>
                                <div className="f-dark f-s-26 text-center">Multi-Factor Authentication</div>
                                <div className="f-gray f-r-14 mt-1 text-center">
                                    Please enter the verification code sent to your phone number:
                                    <label className="f-dark">{phoneNumber}</label>
                                </div>

                                <div className="mt-12 f-s-26" style={{width: 360, margin: '16px auto'}}>
                                    <OTP type="number" size="large" style={{ width: '100%' }} variant="filled" {...sharedProps} />
                                </div>

                                <Space className="mt-6">
                                    {
                                        canResend ?
                                            <div className="f-r-14 f-blue resend select-none cursor-pointer" onClick={sendOtp}>Resend Code</div>
                                            :
                                            <div className="f-r-14 f-gray">
                                                Resend Code ({getSecondsDesc()})
                                            </div>
                                    }
                                    {mfaLoading && <Spin indicator={<LoadingOutlined />} />}
                                </Space>
                            </div>
                            :
                            <div style={{ margin: '0 32px' }}>
                                <div className="email mt-10">
                                    <div className="f-dark f-r-14">Email address</div>
                                    <div className="mt-1 relative">
                                        <Input className="input f-r-16" placeholder="Enter your email address" onChange={emailInput} allowClear />
                                    </div>
                                </div>

                                <div className="email mt-4">
                                    <div className="f-dark f-r-14">Password</div>
                                    <div className="mt-1">
                                        <Password className="input f-r-16" placeholder="Input password" onChange={pwdInput} allowClear />
                                    </div>
                                </div>

                                <Button loading={loading} onClick={confirmLogin} disabled={!email || !pwd} type="primary" className="mt-10 f-m-16 next-btn mb-1" block>Log in</Button>

                            </div>
                    }

                    <div id="recaptcha-container"></div>
                    <div style={{ height: 32 }} />
                </div>
            </div>
        </ConfigProvider>
    );
}

export default LoginPanel;